<template>
  <div v-bind="$attrs">
      <x-select
        v-model="momento"
        getterListPath="momentoModule/getMomentos"
        :formatListWith="['id', 'nombre']"
        no-validate
        default-text="Seleccionar momento contable"
      />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'XSelectMomentoContable',

  data () {
    return {
      momento: null
    }
  },

  props: {
    periodo: null
  },

  computed: {
    ...mapGetters('fiscalPeriodsModule', [
      'getAllFiscalPeriods'
    ])
  },

  watch: {
    momento: {
      immediate: true,
      handler (value) {
        this.onInput(value)
      }
    },

    periodo: {
      immediate: true,
      async handler (value) {
        await this.$store.dispatch('momentoModule/getAll', value)
      }
    }
  },

  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
